import {
  Button,
  CheckIcon,
  ChevronLeftIcon,
  Typography,
} from '@iheartjane/reefer';

import { useNavigateWithBasename } from '@jane/bloom/hooks/navigation/useNavigateWithBasename';
import { useResetPasswordRequestFetcher } from '@jane/bloom/hooks/useResetPasswordRequestFetcher';

import styles from './forgotPassword.module.css';

export function ForgotPassword({ userEmail }: { userEmail: string }) {
  const navigate = useNavigateWithBasename();
  const { sendResetPasswordRequest, state } = useResetPasswordRequestFetcher();

  return (
    <main className={styles['main']}>
      <Button.Icon
        label="Go back"
        icon={<ChevronLeftIcon />}
        onClick={() => navigate('/login/email?reset=1')}
        className={styles['goBackButton']}
      />
      <div className={styles['forgotPassContainer']}>
        <Typography variant="header" className={styles['forgotPassHeader']}>
          Reset password
        </Typography>
        <Typography color="grays-mid" textAlign="center">
          An email with a link to reset your password will be sent to this email
          address.
        </Typography>
        <Typography variant="body-bold" className={styles['forgotPassEmail']}>
          {userEmail}
        </Typography>
        <Button
          label={
            state === 'loading' ? (
              <CheckIcon color="grays-white" />
            ) : (
              'Send email'
            )
          }
          onClick={() => sendResetPasswordRequest(userEmail)}
          className={styles['sendEmailButton']}
          variant="primary"
        />
      </div>
    </main>
  );
}
